
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import TextSearch from '@/components/molecules/TextSearch.vue'
import PageLinkButton from '@/components/organisms/PageLinkButton.vue'
import AcademyBranchListTable from '@/components/organisms/manage/AcademyBranchListTable.vue'
import { BranchList } from '@/models/manage/BranchList'

/**
 * 教室一覧パネル
 */
@Component({
  components: {
    PanelFrame,
    TextSearch,
    PageLinkButton,
    AcademyBranchListTable,
  },
})
export default class AcademyBranchListPanel extends Vue {
  /** テキスト検索欄 */
  @Ref()
  textSearch!: TextSearch

  /** 教室一覧テーブル */
  @Ref()
  academyBranchListTable!: AcademyBranchListTable

  /** 教室一覧 */
  @Prop()
  private branchList!: BranchList[]

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** 検索ボタン押下時の処理 */
  @Prop()
  private eventClickSearch!: () => void

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /**
   * 検索文字列
   *
   * @returns 入力された文字列
   */
  public get textInputed(): string {
    return this.textSearch.text
  }
}
